import axios from "../utils/axios";

export const getAllSchools = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;
    const { data } = await axios.get('/schools', { params });
    return data;
};

export const getSchool = async (id) => {
    const { data } = await axios.get(`/schools/${id}`);
    return data;
};

export const createSchool = async (req) => {
    const { data } = await axios.post('/schools', req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const updateSchool = async (req, id) => {
    const { data } = await axios.put(`/schools/${id}`, req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const deleteSchool = async (id) => {
    const { data } = await axios.delete(`/schools/${id}`, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const deleteAllSchools = async (req) => {
    const { data } = await axios.delete('/schools/mass-destroy', {
        data: req,
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const forceDeleteSchool = async (id) => {
    const { data } = await axios.delete(`/schools/${id}/force-delete`, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const forceDeleteAllSchools = async (ids) => {
    const { data } = await axios.delete('/schools/mass-force-delete', {
        data: ids,
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const restoreSchool = async (id) => {
    const { data } = await axios.post(`/schools/${id}/restore`, {}, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const restoreAllSchools = async (req) => {
    const { data } = await axios.post('/schools/mass-restore', req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};
